/**
 * A global namespace for `Enter` key.
 * e.which = 13 equivalent
 */
const keyEnter = "Enter";

export default keyEnter;
